import { render } from "./RoleDetail.vue?vue&type=template&id=78467aa1&ts=true"
import script from "./RoleDetail.vue?vue&type=script&lang=ts"
export * from "./RoleDetail.vue?vue&type=script&lang=ts"

import "./RoleDetail.vue?vue&type=style&index=0&id=78467aa1&lang=css"

import exportComponent from "D:\\Work\\IMMS\\IMMSV3\\App\\IMMS.MasterClient\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/RoleDetail.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "78467aa1"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('78467aa1', __exports__)) {
    console.log('reload')
    api.reload('78467aa1', __exports__)
  }
  
  module.hot.accept("./RoleDetail.vue?vue&type=template&id=78467aa1&ts=true", () => {
    console.log('re-render')
    api.rerender('78467aa1', render)
  })

}


export default __exports__